import { render } from "./ProductRecommendCollection.vue?vue&type=template&id=36f5a747&scoped=true"
import script from "./ProductRecommendCollection.vue?vue&type=script&lang=js"
export * from "./ProductRecommendCollection.vue?vue&type=script&lang=js"

import "./ProductRecommendCollection.vue?vue&type=style&index=0&id=36f5a747&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f5a747"]])

export default __exports__